import $ from 'jquery/dist/jquery.js';

document.addEventListener('DOMContentLoaded', () => {
  const items = document.getElementsByClassName('datepicker');
  if (items.length === 0) {
    return;
  }
  [].forEach.call(items, item => {
    const format = (item as any).getAttribute('data-format');
    const startDate = (item as any).getAttribute('data-min-date');
    const endDate = (item as any).getAttribute('data-max-date');

    if(format && startDate && endDate) {  // レポーティング機能の時だけ
      $(item).datepicker({
        language: 'ja',
        weekStart: 1, // 月曜始まり
        ...{
          format,
          startDate,
          endDate,
        },
      }).datepicker(
        'setDate', (item as any).getAttribute('data-default-date')
      );
    } else {
      $(item).datepicker({
        language: 'ja',
        format: 'yyyy-mm-dd',
        weekStart: 1, // 月曜始まり
      });
    }
  });
});
